module.exports = __webpack_public_path__ + "static/media/cursor_pause.20e0ee9b.svg";